import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';

import { AppComponent } from './app.component';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TextareaModule } from 'primeng/textarea';
import { MenubarModule } from 'primeng/menubar';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { AppConfigService } from './app-config.service';
import { InfoPageComponent } from './info-page/info-page.component';
import { AppRoutingModule } from './app-routing.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { MainMenuService } from './menu/main-menu.service';
import { AuthService } from './auth/auth.service';
import { AuthGuard } from './auth/auth-guard.service';
import { DataService } from './data.service';
import { MenuComponent } from './menu/menu.component';
import { FormsModule } from '@angular/forms';
import { AuthModule } from './auth/auth.module';
import { GtagService } from './gtag/gtag.service';
import { ToastModule } from 'primeng/toast';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ClientPanelModule } from './client-panel/client-panel.module';
import { StoragePanelModule } from './storage-panel/storage-panel.module';
import { AdminPanelModule } from './admin-panel/admin-panel.module';
import { RootPanelModule } from './root-panel/root-panel.module';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import Lara from '@primeng/themes/lara';
import Material from '@primeng/themes/material';

const appInitializerFn = (appConfig: AppConfigService) => {
    return () => {
        return appConfig.loadAppConfig();
    };
}

@NgModule({ declarations: [
        AppComponent,
        MenuComponent,
        // CheckTrackComponent,  
        // LostPackagesComponent,
        // ClientsDashboardComponent,
        InfoPageComponent,
    ],
    bootstrap: [AppComponent], 
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        FormsModule,
        AppRoutingModule,
        AuthModule,
        AdminPanelModule,
        ClientPanelModule,
        StoragePanelModule,
        // RootPanelModule,
        MenubarModule,
        ButtonModule,
        TextareaModule,
        DialogModule,
        ToastModule,
        ConfirmDialogModule
    ], 
    providers: [
        DataService,
        AuthService,
        AuthGuard,
        ConfirmationService,
        MessageService,
        MainMenuService,
        GtagService,
        AppConfigService,
        {
            provide: APP_INITIALIZER,
            deps: [AppConfigService],
            multi: true,
            useFactory: appInitializerFn,
        },
        provideHttpClient(withInterceptorsFromDi()),
        
        provideAnimationsAsync(),
        providePrimeNG(
            {
              theme: {
                preset: Aura,
                options: {
                  prefix: 'p',
                  darkModeSelector: 'system1',
                  cssLayer: false
                }
              },
              ripple: true,
            })
    ] })
export class AppModule {
}
